import { SignUpForm } from '../components/templates';

const SignUpPage = () => {
  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContents: 'center',
      }}
    >
      <SignUpForm />
    </div>
  );
};

export default SignUpPage;
